import api from '@/lib/api';

// Константы мутаций (внутренние)
const ON_SITE_NOTIFICATIONS_LOADING_CHANGE = 'ON_SITE_NOTIFICATIONS_LOADING_CHANGE';
const ON_SITE_NOTIFICATIONS_SAVING_CHANGE = 'ON_SITE_NOTIFICATIONS_SAVING_CHANGE';
const ON_SITE_NOTIFICATIONS_LIST_CHANGE = 'ON_SITE_NOTIFICATIONS_LIST_CHANGE';
const ON_SITE_NOTIFICATIONS_ITEM_CHANGE = 'ON_SITE_NOTIFICATIONS_ITEM_CHANGE';
const ON_SITE_NOTIFICATIONS_ITEM_DELETE = 'ON_SITE_NOTIFICATIONS_ITEM_DELETE';
const ON_SITE_NOTIFICATIONS_ERRORS_CHANGE = 'ON_SITE_NOTIFICATIONS_ERRORS_CHANGE';
const ON_SITE_NOTIFICATIONS_CREATED_WITH_SECRET_CHANGE = 'ON_SITE_NOTIFICATIONS_CREATED_WITH_SECRET_CHANGE';

const state = {
  // Список сайтов
  sites: [],

  // Текущий сайт для просмотра кода
  currentSite: null,

  // Состояния загрузки
  isLoading: false,
  isSaving: false,

  // Ошибки
  errors: {},

  // Созданный сайт с secret key (для одноразового показа)
  createdSiteWithSecret: null,
};

const actions = {
  /**
     * Загрузка списка сайтов текущей организации
     */
  ON_SITE_NOTIFICATIONS_LOAD({ commit, state }, { organization_id, params = {} } = {}) {
    const options = params.options || {};

    return api.load(
      'on_site_notifications',
      organization_id,
      state,
      commit,
      ON_SITE_NOTIFICATIONS_LOADING_CHANGE,
      ON_SITE_NOTIFICATIONS_LIST_CHANGE,
      ON_SITE_NOTIFICATIONS_ERRORS_CHANGE,
      options,
    );
  },

  /**
     * Создание нового сайта
     */
  ON_SITE_NOTIFICATIONS_CREATE({ commit, state }, params) {
    const { model } = params;
    const options = params.options || {};

    return api.create(
      'on_site_notifications',
      '',
      model,
      state,
      commit,
      ON_SITE_NOTIFICATIONS_SAVING_CHANGE,
      ON_SITE_NOTIFICATIONS_CREATED_WITH_SECRET_CHANGE,
      ON_SITE_NOTIFICATIONS_ERRORS_CHANGE,
      options,
    );
  },

  /**
     * Обновление сайта
     */
  ON_SITE_NOTIFICATIONS_UPDATE({ commit, state }, params) {
    const { model } = params;
    const options = params.options || {};

    return api.update(
      'on_site_notification',
      model.id, // ID записи для обновления
      model,
      state,
      commit,
      ON_SITE_NOTIFICATIONS_SAVING_CHANGE,
      ON_SITE_NOTIFICATIONS_ITEM_CHANGE,
      ON_SITE_NOTIFICATIONS_ERRORS_CHANGE,
      options,
    );
  },

  /**
     * Удаление (архивирование) сайта
     */
  ON_SITE_NOTIFICATIONS_DELETE({ commit, state }, params) {
    const siteId = params.id;
    const options = params.options || {};

    return api.delete(
      'on_site_notification',
      siteId,
      state,
      commit,
      ON_SITE_NOTIFICATIONS_ITEM_DELETE,
      options,
    );
  },
};

const mutations = {
  ON_SITE_NOTIFICATIONS_LOADING_CHANGE(state, isLoading) {
    state.isLoading = isLoading;
  },

  ON_SITE_NOTIFICATIONS_SAVING_CHANGE(state, isSaving) {
    state.isSaving = isSaving;
  },

  ON_SITE_NOTIFICATIONS_LIST_CHANGE(state, response) {
    if (response && response.data) {
      state.sites = Array.isArray(response.data) ? response.data : [];
    } else {
      state.sites = [];
    }
  },

  ON_SITE_NOTIFICATIONS_ITEM_CHANGE(state, response) {
    if (response && response.data) {
      const updatedSite = response.data;
      const index = state.sites.findIndex((site) => site.id === updatedSite.id);

      if (index !== -1) {
        // Обновляем существующий сайт
        state.sites.splice(index, 1, updatedSite);
      } else {
        // Добавляем новый сайт
        state.sites.push(updatedSite);
      }
    }
  },

  ON_SITE_NOTIFICATIONS_ITEM_DELETE(state, siteId) {
    state.sites = state.sites.filter((site) => site.id !== siteId);
  },

  ON_SITE_NOTIFICATIONS_ERRORS_CHANGE(state, errors) {
    state.errors = errors || {};
    state.isLoading = false;
    state.isSaving = false;
  },

  ON_SITE_NOTIFICATIONS_CREATED_WITH_SECRET_CHANGE(state, response) {
    if (response && response.data) {
      const newSite = response.data;

      // Сохраняем сайт с secret key для одноразового показа
      state.createdSiteWithSecret = newSite;

      // Добавляем сайт в список (без secret key)
      const siteForList = { ...newSite };
      delete siteForList.secret_key;
      state.sites.push(siteForList);
    }
  },

  // Очистка созданного сайта с secret key после показа
  ON_SITE_NOTIFICATIONS_CLEAR_CREATED_SECRET(state) {
    state.createdSiteWithSecret = null;
  },

  // Очистка текущего сайта
  ON_SITE_NOTIFICATIONS_CLEAR_CURRENT_SITE(state) {
    state.currentSite = null;
  },

  // Установка текущего сайта для отображения кода
  ON_SITE_NOTIFICATIONS_CURRENT_SITE_CHANGE(state, site) {
    state.currentSite = site;
  },
};

const getters = {
  // Проверка наличия сайтов (геттер с логикой)
  hasSites: (state) => state.sites.length > 0,

  // Получение сайта по ID (геттер с логикой)
  getSiteById: (state) => (id) => state.sites.find((site) => site.id === id),
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
